import { connect } from "react-redux";
import get from "lodash/get";

import {
  getUsers as onGetUsers,
  getUser as onGetUser,
  blockStates as onBlockStates,
  createUser as onCreateUser,
  createUserLocalVersion as onCreateUserLocalVersion,
  createUserPermission as onCreateUserPermission,
  deleteUserPermission as onDeleteUserPermission,
  createUserOwnershipArea as onCreateUserOwnershipArea,
  deleteUserOwnershipArea as onDeleteUserOwnershipArea,
  clearCurrentUser as onClearCurrentUser,
  createUserUnit as onCreateUserUnit,
  deleteUserUnit as onDeleteUserUnit,
  updateUserPassword as onUpdateUserPassword,
} from "../../actions/usersActions";

const mapStateToProps = (state) => ({
  usersDataState: state.users.usersDataState,
  currentUserDataState: state.users.currentUserDataState,
  blockStatesDataState: state.users.blockStatesDataState,
  createUserDataState: state.users.createUserDataState,
  createUserUnitDataState: state.users.createUserUnitDataState,
  deleteUserUnitDataState: state.users.deleteUserUnitDataState,
  userPermissionDataState: state.users.userPermissionDataState,
  userOwnershipAreaDataState: state.users.userOwnershipAreaDataState,
  updateUserPasswordDataState: state.users.updateUserPasswordDataState,
  users: get(state, ["users", "users"], []),
  currentUser: get(state, ["users", "currentUser"], null),
  errors: get(state, ["users", "errors"], null),
});

const mapDispatchToProps = {
  onGetUsers,
  onGetUser,
  onBlockStates,
  onCreateUser,
  onCreateUserLocalVersion,
  onCreateUserPermission,
  onDeleteUserPermission,
  onCreateUserOwnershipArea,
  onDeleteUserOwnershipArea,
  onClearCurrentUser,
  onCreateUserUnit,
  onDeleteUserUnit,
  onUpdateUserPassword,
};

const withUsers = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withUsers };
